import { DealersService } from 'src/services/dealers.service';
import { IUser } from 'src/utils/interfaces/user';
import { MODAL_CONTROL_ACTIONS } from 'src/utils/enums/user-store-actions.enum';
import Profile from './Profile/Profile';
import Spinner from 'src/components/ui/spinner';
import {
    DealerAssociation,
    DealerPermission,
} from 'src/services/models/dealer-management.service';
import {
    IDealerAssociation,
    IPermission,
} from 'src/services/dealer-management.service';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './styles.scss';

interface IBodyProps {
    backClickHandler: Function;
    setErrorNotification: Dispatch<SetStateAction<boolean>>;
    username: string;
    dealerPermissions: Array<DealerPermission>;
    dealerAssociations: Array<DealerAssociation>;
    setShouldLoadList: Dispatch<SetStateAction<boolean>>;
    setIsUserActive: Dispatch<SetStateAction<boolean>>;
    isUserActive: boolean;
    setIsSuccessDeleted: Dispatch<SetStateAction<boolean>>;
    showOnlyDeleteOption?: boolean;
    isDSMSearch?: boolean;
}

export interface IUserData {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    partyId: number;
    userId: string;
    userStatus: number;
    userPermissions: Array<IPermission>;
    associations: Array<IDealerAssociation>;
    isUserLocked: boolean;
}

const Body: React.FC<IBodyProps> = ({
    backClickHandler,
    setErrorNotification,
    username,
    dealerPermissions,
    dealerAssociations,
    setShouldLoadList,
    setIsUserActive,
    isUserActive,
    setIsSuccessDeleted,
    showOnlyDeleteOption,
    isDSMSearch = false,
}) => {
    const [fullName, setFullName] = useState<string>('');
    const [userData, setUserData] = useState<IUserData>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const dispatch = useDispatch();

    const dealerId = useSelector((state: IUser) => {
        return state.currentDealers?.default ?? '';
    });

    async function getDealerUserData(didUpdate = false) {
        const service = new DealersService();
        try {
            const res = await service.getUserData(username, dealerId);
            setIsLoading(false);
            if (res?.data) {
                const user = mapUserDataResponse(res.data);
                setFullName(`${user.firstName} ${user.lastName}`);
                setUserData(user);
                setShouldLoadList(didUpdate);
                setIsUserActive(isStatusActive(user.userStatus));
            }
        } catch (error) {
            setIsLoading(false);
            dispatch({
                type: MODAL_CONTROL_ACTIONS.SET_INACTIVE,
            });
            backClickHandler(false);
            setErrorNotification(true);
        }
    }

    function deleteSuccessHandler() {
        setIsLoading(false);
        dispatch({
            type: MODAL_CONTROL_ACTIONS.SET_INACTIVE,
        });
        backClickHandler(false, true);
        setIsSuccessDeleted(true);
    }

    useEffect(() => {
        setIsLoading(true);
        getDealerUserData();
    }, []);

    return (
        <div className={'edit-user-container__body'}>
            {isLoading ? (
                <div className='edit-user__spinner'>
                    <Spinner />
                </div>
            ) : (
                <div className='edit-user-container__content'>
                    {userData && (
                        <Profile
                            userData={userData}
                            fullName={fullName}
                            dealerPermissions={dealerPermissions}
                            dealerAssociations={dealerAssociations}
                            getDealerUserData={getDealerUserData}
                            isUserActive={isUserActive}
                            deleteSuccessHandler={deleteSuccessHandler}
                            showOnlyDeleteOption={showOnlyDeleteOption}
                            isDSMSearch={isDSMSearch}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

function mapUserDataResponse(data: any): IUserData {
    const {
        dsourceProfile,
        userProfile,
        userPermissions,
        associations,
        ldapLockStatus,
    } = data;
    const phone = selectPhoneNumber(dsourceProfile.user.phoneNumbers);

    const user = {
        firstName: dsourceProfile.user.firstName || '',
        lastName: dsourceProfile.user.lastName || '',
        phone,
        email: userProfile.userLoginId,
        partyId: userProfile.userPartyId,
        userId: userProfile.userId,
        userStatus: userProfile.userStatus,
        userPermissions: userPermissions,
        associations: associations,
        isUserLocked: ldapLockStatus.isUserLocked,
    };

    if (!user.email || !user.partyId || !user.userId) {
        throw Error();
    }

    return user;
}

function selectPhoneNumber(
    phoneNumbers: Array<{
        areaCode: string;
        contactNumber: string;
        telecomunicationId: number;
        telecomunicationType: number;
    }>,
): string {
    let phoneNumber = '';
    const EMPTY_ARRAY = 0;

    if (phoneNumbers && phoneNumbers.length > EMPTY_ARRAY) {
        phoneNumber = `${phoneNumbers[0].areaCode}${phoneNumbers[0].contactNumber}`;
    }

    return phoneNumber;
}

function isStatusActive(status: number): boolean {
    const ACTIVE_STATUS_NUMBER = 0;
    return status == ACTIVE_STATUS_NUMBER;
}
export default Body;
